import React, { useRef, useState, useEffect } from 'react';
import './Home.css';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import Typed from 'typed.js';
import Accordion from 'react-bootstrap/Accordion';
import logo from '../assets/images/logo-dark.png';




import { RiSettings4Fill } from "react-icons/ri";
import { BsFire } from "react-icons/bs";
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import AOS from 'aos';
import 'aos/dist/aos.css';


import { FaFacebookF } from "react-icons/fa";

import { FaInstagram } from 'react-icons/fa';
import { FaLinkedinIn } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";
import { GrMapLocation } from "react-icons/gr";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { TfiEmail } from "react-icons/tfi";
import { TbClockHour9 } from "react-icons/tb";








import imgs from '../assets/images/banner-1.jpeg';
import digital from '../assets/images/digital-marketing.jpg';
import website from '../assets/images/Website-Design-Development.jpg';
import Social from '../assets/images/Social-Media-Marketing-Platform-Selection-scaled-1.jpg';
import branding from '../assets/images/branding_overview_371705137.jpg';

import setting from '../assets/images/1.png';
import setting1 from '../assets/images/2.png';
import setting2 from '../assets/images/3.png';

import incremant1 from '../assets/images/1(1).png';
import incremant2 from '../assets/images/2(1).png';
import incremant3 from '../assets/images/3(1).png';
import incremant4 from '../assets/images/4.png';

import industry1 from '../assets/images/video.png';
import industry2 from '../assets/images/healthy-drink.png';
import industry3 from '../assets/images/corporate-event.png';
import industry4 from '../assets/images/manufacture.png';
import industry5 from '../assets/images/content.png';
import industry6 from '../assets/images/healthcare.png';
import industry7 from '../assets/images/bank.png';
import industry8 from '../assets/images/agreement.png';
import industry9 from '../assets/images/travel-and-tourism.png';
import industry10 from '../assets/images/graduation-cap.png';
import industry11 from '../assets/images/shopping-store.png';
import industry12 from '../assets/images/charity.png';
import industry13 from '../assets/images/electric-vehicle.png';
import industry14 from '../assets/images/hook.png';
import industry15 from '../assets/images/starry-night.png';
import industry16 from '../assets/images/dumbbell.png';




import Teamets from '../assets/images/Arif-Siddiqui-(Founder-and-Ceo).jpg';
import Teamets1 from '../assets/images/square_image.jpg';
import Teamets2 from '../assets/images/Amy-J.jpg';
import Teamets3 from '../assets/images/Male.jpg';

import CARD0 from '../assets/images/performance-marketing.png';
import CARDS1 from '../assets/images/cs2.webp';
import CARDS2 from '../assets/images/cs3.webp';
import CARDS3 from '../assets/images/cs1.webp';

import TRIPS11 from '../assets/images/4.jpg';
import TRIPS123 from '../assets/images/4.jpg';
import TRIPS1234 from '../assets/images/4.jpg';





function Home() {
  const buttonRef = useRef(null);
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animated) {
          buttonRef.current.classList.add('animate');
          setAnimated(true);
        }
      },
      { threshold: 0.6 }
    );

    if (buttonRef.current) {
      observer.observe(buttonRef.current);
    }

    return () => {
      if (buttonRef.current) {
        observer.unobserve(buttonRef.current);
      }
    };
  }, [animated]);
  const { ref, inView } = useInView({ triggerOnce: true });

  const counters = [
    { end: 1000, title: "Happy Clients", img: incremant1 },
    { end: 10, title: "Years Experience", img: incremant2 },
    { end: 100, title: "Verified Reviews", img: incremant3 },
    { end: 30, title: "Team Members", img: incremant4 },
  ];

  useEffect(() => {
    AOS.init({
      duration: 400,
      easing: 'ease',
      once: true
    });
  }, []);

  const industries = [
    {
      name: "Entertainment & Media",
      icon: industry1,
      link: "industries/entertainment-media"
    },
    {
      name: "Food & Beverage",
      icon: industry2,
      link: "industries/food-beverage"
    },
    {
      name: "Events & Corporate",
      icon: industry3,
      link: "industries/events-corporate"
    },
    {
      name: "Manufacturing",
      icon: industry4,
      link: "industries/manufacturing"
    },
    {
      name: "Creators & Influencers",
      icon: industry5,
      link: "industries/creators-influencers"
    },
    {
      name: "Healthcare",
      icon: industry6,
      link: "industries/healthcare"
    },
    {
      name: "Finance & Banking",
      icon: industry7,
      link: "industries/finance-banking"
    },
    {
      name: "Real Estate",
      icon: industry8,
      link: "industries/real-estate"
    },
    {
      name: "Travel & Hospitality",
      icon: industry9,
      link: "industries/travel-hospitality"
    },
    {
      name: "Education",
      icon: industry10,
      link: "industries/education"
    },
    {
      name: "Retail",
      icon: industry11,
      link: "industries/retail"
    },
    {
      name: "Non Profit",
      icon: industry12,
      link: "industries/non-profit"
    },
    {
      name: "Automotive",
      icon: industry13,
      link: "industries/automotive"
    },
    {
      name: "Construction",
      icon: industry14,
      link: "industries/construction"
    },
    {
      name: "Arts & Culture",
      icon: industry15,
      link: "industries/arts-culture"
    },
    {
      name: "Fitness & Wellness",
      icon: industry16,
      link: "industries/fitness-wellness"
    }
  ];
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Digital Strategy.", "Performance Marketing.", "Social Media Magic."],
      typeSpeed: 100,
      backSpeed: 60,
      loop: true,
    });
    return () => {

      typed.destroy();
    };
  }, []);


  const blogs = [
    {
      img: TRIPS11,
      category: 'Web Development',
      title: 'Stay Productive at Home',
      text: 'Tech products that help remote productivity...',
      link: 'blog-detail.php'
    },
    {
      img: TRIPS123,
      category: 'Software Development',
      title: 'Virtual Court System Revolution',
      text: 'How necessity is pushing innovation in court systems....',
      link: 'blog-detail.php'
    },
    {
      img: TRIPS1234,
      category: 'Web Developments',
      title: 'Stay Productive at Homes',
      text: 'Tech products that help remote productivity.s...',
      link: 'blog-detail.php'
    }
  ];


  return (
    <div className="home-container">
      <Carousel>
        <Carousel.Item>
          <img className="carousel-img" alt="First slide" src={imgs} />
        </Carousel.Item>
        <Carousel.Item>
          <img className="carousel-img" alt="Second slide" src={imgs} />
        </Carousel.Item>
      </Carousel>

      <div className="services-section">
        <div className='ser_BTN'>
          <button>SERVICES</button>
        </div>
        <div className='content-container'>
          <div className='content-card'>
            <img src={digital} alt="Digital Marketing" />
            <h3>Digital Marketing</h3>
            <p>Digital Marketing</p>
          </div>
          <div className='content-card'>
            <img src={website} alt="Website Development" />
            <h3>Website & App Development</h3>
            <p>Website Development</p>
          </div>
          <div className='content-card'>
            <img src={Social} alt="Social Media" />
            <h3>Social Media Management</h3>
            <p>Social Media</p>
          </div>
          <div className='content-card'>
            <img src={branding} alt="Branding" />
            <h3>Social Media Optimization</h3>
            <p>Social Media Optimization</p>
          </div>
        </div>
      </div>

      <div>
        <div className='About-US'>
          {/* <img src="" alt="" /> */}
          <div className='BTN-ABOUT'>
            <button ref={buttonRef}>ABOUT US</button>
          </div>
          <div className='about-didital'>
            <h3>About Zephire Digital</h3>
            <p>
              <strong>Zephire Digital</strong> is a leading full-stack digital agency helping brands, creators, and entrepreneurs scale their digital presence with measurable results. We don’t just help you go online, we help you build a high-performance digital ecosystem. From launching D2C platforms and managing marketplaces to building creator brands and producing engaging content, we offer all-in-one digital transformation.
            </p>
            <p>With a team of experts across strategy, design, content, and growth, we specialize in delivering complete, platform-integrated solutions that boost visibility, credibility, engagement, and revenue.
            </p>
          </div>
          <div className='ICON-FIRE'>
            <RiSettings4Fill />
            <BsFire />
          </div>
          <div className='EXP'>
            <h2>Experience</h2>
            <h2>Quick Support</h2></div>
          <div className='EXP-PARA'>
            <p>We have a decent team with an <br />honest and great experience.</p>
            <p>Our services are available 24*7 for <br />our clients.</p></div>

        </div>
      </div>
      <div className='PARANT'>
        <div className='BTN-WHYCHOOSE'>
          <button ref={buttonRef}>WHY CHOOSE US</button>
        </div>

        <div className='content-container1'>
          <div className='content-card1'>
            <img src={setting} alt="Digital Marketing" />
            <h3>Expert Team</h3>
            <p>We have a team of digital marketing experts who ensure maximum ROI with proven strategies.</p>
          </div>
          <div className='content-card1'>
            <img src={setting1} alt="Digital Marketing" />
            <h3>Tailored Strategies
            </h3>
            <p>Every business is different. We craft strategies <br />tailored to your goals and audience.
            </p>
          </div>
          <div className='content-card1'>
            <img src={setting2} alt="Digital Marketing" />
            <h3>Transparent Reporting
            </h3>
            <p>We provide clear, detailed reports so you can track your growth and results easily.
            </p>
          </div>
        </div></div>
      <div className="count-incremant1">
        <div className="count-incremant" ref={ref}>
          {counters.map((item, idx) => (
            <div key={idx} className="rs-counter style2">
              <div className="counter-content">
                <div className="icon-number">
                  <img src={item.img} alt="icon" className="counter-icon" />
                  <div className="count-number">
                    {inView && (
                      <CountUp
                        start={0}
                        end={item.end}
                        duration={2.5}
                        separator=","
                        suffix="+"
                      />
                    )}
                  </div>
                </div>
                <h3 className="title">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>


      <div>
        <div className="container">
          <div className="sec-title2 text-center mb-20">
            <span className="sub-text style-bg hidden-anim">Industry</span>
          </div>

          <div className="row justify-content-center pt-20 pb-20 md-pt-0 md-pb-20">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="col-lg-2 col-md-2 col-sm-4 col-3"
                data-aos="zoom-in-up"
                data-aos-duration="400"
              >
                <div className="services-item">
                  <div className="services-icon">
                    <div className="image-part">
                      <a href={industry.link}>
                        <img
                          src={industry.icon}
                          alt={industry.name}
                          style={{ height: '80px', width: '80px' }}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="services-content">
                    <div className="services-text">
                      <h3 className="services-title">
                        <a href={industry.link}>{industry.name}</a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className='INDUS-BTN'>
            <div className='BTN-WHYCHOOSE'>
              <button ref={buttonRef}>INDUSTRY</button>
            </div>

          </div>
        </div>

      </div>

      <div className='TEAMS'>

        <Carousel>
          <Carousel.Item>
            <div className='TEAMS'>

              <div className='TEAM-BTN'>
                <div className='BTN-TEAMESS'>
                  <button ref={buttonRef}>TEAME</button>
                </div>
                <h2>Meet Out Teame</h2>
              </div>
              <div className="team-grid-container">
                <div className="content-card2">
                  <img src={Teamets} alt="Team Member" />
                  <h3>Arif Siddiqui
                  </h3>
                  <p>Founder & CEO

                  </p>
                </div>
                <div className="content-card2">
                  <img src={Teamets1} alt="Team Member" />
                  <h3>Divya D
                  </h3>
                  <p>Social Media Strategist

                  </p>
                </div>
                <div className="content-card2">
                  <img src={Teamets2} alt="Team Member" />
                  <h3>Amy J
                  </h3>
                  <p>Content Specialist

                  </p>
                </div>
                <div className="content-card2">
                  <img src={Teamets3} alt="Team Member" />
                  <h3>Gaus M
                  </h3>
                  <p>Video Production Manager</p>
                </div>
              </div>
            </div>


          </Carousel.Item>
          <Carousel.Item>
            <div className='TEAMS'>

              <div className='TEAM-BTN'>
                <div className='BTN-TEAMESS'>
                  <button ref={buttonRef}>TEAME</button>
                </div>
                <h2>Meet Out Teame</h2>
              </div>
              <div className="team-grid-container">
                <div className="content-card2">
                  <img src={Teamets3} alt="Team Member" />
                  <h3>Justin Jacob
                  </h3>
                  <p>Cheif Marketing Officer

                  </p>
                </div>
                <div className="content-card2">
                  <img src={Teamets3} alt="Team Member" />
                  <h3>Gaus M
                  </h3>
                  <p>Video Production Manager

                  </p>
                </div></div>
            </div>
          </Carousel.Item>
        </Carousel>

      </div>


      <div className='EXPLOR'>
        <div className='H-BTN'>
          <h2>Explore Our Packages</h2></div>
        <div className='Common-Container'>
          <div className="card" style={{ width: '18rem' }}
            data-aos="flip-left"
          >
            <img
              className="card-img-top"
              src={CARD0}
              alt="Card image cap"
            />
            <div className="card-body">
              <h5 className="card-title">E-commerce Store Setup</h5>
              <p className="card-text">Complete D2C brand launch and growth.
              </p>
              <h6>Starts Onwards ₹150000</h6>
              <ul>
                <li>Website & mobile app development</li>
                <li>Payment integration</li>
                <li>Product listing & catalog setup</li>
                <li>Branding, logo & packaging</li>
                <li><span>20+ services</span> </li>
              </ul>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '85px' }}>
                <button className="btn-orange">View Details</button>
                <button className="btn-green">Buy</button>
              </div>

            </div>
          </div>


          <div className="card" style={{ width: '18rem' }} data-aos="flip-left"
          >
            <img
              className="card-img-top"
              src={CARD0}
              alt="Card image cap"
            />
            <div className="card-body">
              <h5 className="card-title">E-commerce Marketplace Management</h5>
              <p className="card-text">Sell and scale on Flipkart, Amazon, Meesho & more
              </p>
              <h6>Starts Onwards ₹30000</h6>
              <ul>
                <li>Product listing optimization
                </li>
                <li>Branding & SEO support
                </li>
                <li>Performance marketing & ads
                </li>
                <li>Influencer and affiliate marketing</li>
                <li><span>20+ services</span> </li>
              </ul>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '60px' }}>
                <button className="btn-orange">View Details</button>
                <button className="btn-green">Buy</button>
              </div>

            </div>
          </div>


          <div className="card" style={{ width: '18rem' }} data-aos="flip-left"
          >
            <img
              className="card-img-top"
              src={CARD0}
              alt="Card image cap"
            />
            <div className="card-body">
              <h5 className="card-title">Artist Online Presence Management
              </h5>
              <p className="card-text">
                Digital launchpad for artists and creators.</p>
              <h6>Starts Onwards ₹45000

              </h6>
              <ul>
                <li>🎨 Brand Identity & Visual Design
                </li>
                <li>🌐 Website for Artists
                </li>
                <li>📱 Social Media Management
                </li>
                <li>🎮 YouTube Channel Growth & Monetization</li>
                <li><span>20+ services</span> </li>
              </ul>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
                <button className="btn-orange">View Details</button>
                <button className="btn-green">Buy</button>
              </div>




            </div>
          </div>

          <div className="card" style={{ width: '18rem' }} data-aos="flip-left"
          >
            <img
              className="card-img-top"
              src={CARD0}
              alt="Card image cap"
            />
            <div className="card-body">
              <h5 className="card-title">Card title</h5>
              <p className="card-text">
                Some quick example text to build on the card title and make up the
                bulk of the card's content.
              </p>

              <h6>Starts Onwards ₹45000

              </h6>
              <ul>
                <li>Product listing optimization
                </li>
                <li>Branding & SEO support
                </li>
                <li>Performance marketing & ads
                </li>
                <li>Influencer and affiliate marketing</li>
                <li><span>20+ services</span> </li>
              </ul>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '60px' }}>
                <button className="btn-orange">View Details</button>
                <button className="btn-green">Buy</button>
              </div>


            </div>
          </div>
          <div><button className='btn-green1'>View All Packages</button></div>
        </div>
      </div>


      <div>

        <div className='Com-imagecard'>
          <div className='BTN-CASE'>
            <button ref={buttonRef}>Case Studies</button>
          </div>
          <div className='CARDS-IMG2'>
            <img src={CARDS1} alt="Card 1" />
            <img src={CARDS2} alt="Card 2" />
            <img src={CARDS3} alt="Card 3" />
          </div>
        </div>

      </div>


      <div className="com-contacts">
        <div className="contact-container">
          {/* Left side */}
          <div className="contact-left">
            <h1>Let's Talk</h1>
            <p><span className="typing" ref={el}></span></p>
          </div>

          {/* Right side */}
          <div className="contact-right">
            <h2>Contact Us</h2>
            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="tel" placeholder="Phone Number" required />
              <input type="email" placeholder="Email Address" required />
              <select>
                <option>Select a Service</option>
                <option>Web Development</option>
                <option>Marketing</option>
                <option>Brand Strategy</option>
              </select>
              <textarea rows="5" placeholder="Your Message" required></textarea>


              <div className="captcha">
                <div className="fake-captcha">I'm not a robot [reCAPTCHA]</div>
              </div>

              <button type="submit">Submit Now</button>
            </form>
          </div>
        </div>
      </div>


      <div className='COM-TRIP'>
        <div className='Read-trip'>
          <h5>Read Our Latest Tips & Tricks
          </h5>
        </div>
        <div className="container-trip">
          <div className="row g-4 justify-content-between">
            {blogs.map((blog, index) => (
              <div className="col-md-4 d-flex" key={index}>
                <div className="custom-card text-white w-100">
                  <img src={blog.img} className="card-img-top" alt="Blog" />
                  <div className="card-body">
                    <span className="badge bg-dark mb-2">{blog.category}</span>
                    <h5 className="card-title">{blog.title}</h5>
                    <p className="card-text">{blog.text}</p>
                    <a href={blog.link} className="btn btn-light btn-sm mt-3">Read More</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>

      <div className='FAQ-QUS'>
        <div className='FAQ-BTN'>
          <button ref={buttonRef}>FAQ</button>
        </div>
        <div className='Action'>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is the difference between SEO and SEM?</Accordion.Header>
              <Accordion.Body>
                SEO focuses on improving your website's organic search engine rankings through optimization techniques, while SEM involves paid advertising on search engines to appear at the top of search results.
              </Accordion.Body>
            </Accordion.Item></Accordion>


          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>How long does it take to see results from digital marketing campaigns?</Accordion.Header>
              <Accordion.Body>
                The timeline for seeing results varies depending on factors like industry and competition. However, you can generally expect to start seeing some results within a few months.
              </Accordion.Body>
            </Accordion.Item></Accordion>

          <Accordion>
            <Accordion.Item eventKey="2">
              <Accordion.Header>How do you measure the success of a digital marketing campaign?</Accordion.Header>
              <Accordion.Body>
                We measure success using KPIs such as website traffic, lead generation, conversion rates, ROI, social media engagement, and brand awareness.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion></div>

      </div>



      <footer id="rs-footer" className="rs-footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">


              <div className="col-lg-3 col-md-12 col-sm-12 footer-widget">
                <div className="footer-logo mb-30">
                  <img className='foot-img' src={logo} alt="" />
                </div>
                <div className="textwidget pb-30">
                  <p>At Zephire Digital, we transform businesses with cutting-edge digital strategies and solutions.</p>
                </div>
                <div className='React-Icon'>

                  <div className="icon-circle">

                    <FaFacebookF className='instagram-icon' />

                  </div>


                  <div className="icon-circle">

                    <RiTwitterXFill className="instagram-icon" />

                  </div>
                  <div className="icon-circle">
                    <FaLinkedinIn className="instagram-icon" />

                  </div>
                  <div className="icon-circle">

                    <FaInstagram className="instagram-icon" />
                  </div>

                </div>

              </div>



              <div className="col-lg-3 col-md-12 col-sm-12 pl-45 md-pl-15 md-mb-30">
                <h3 className="widget-title">Explore Our Site</h3>
                <ul className="site-map">
                  <li><a href="career">Career</a></li>
                  <li><a href="login">Login</a></li>
                  <li><a href="privacy-policy">Privacy Policy</a></li>
                  <li><a href="policy-refund">Refund Policy</a></li>
                  <li><a href="terms-and-conditions">Terms & Conditions</a></li>
                </ul>
              </div>







              <div className="col-lg-3 col-md-12 col-sm-12 md-mb-30">
                <h3 className="widget-title">Registered Office</h3>
                <ul className="address-widget">
                  <li>
                    <i><GrMapLocation className="icon" /></i>
                    <span className="desc">Office No-168, First Floor, Topiwala Center, Goregaon West, Mumbai, Maharashtra 400104</span>
                  </li>
                  <li>
                    <i><LiaPhoneVolumeSolid className="icon" /></i>
                    <span className="desc"><a href="tel:+916392425516">+91 6392425516</a></span>
                  </li>
                  <li>
                    <i><TfiEmail className="icon" /></i>
                    <span className="desc"><a href="mailto:hello@zephiredigital.com">hello@zephiredigital.com</a></span>
                  </li>
                  <li>
                    <i><TbClockHour9 className="icon" /></i>
                    <span className="desc">Opening Hours: 09:00 - 20:00</span>
                  </li>
                </ul>
              </div>

              <div className="col-lg-3 col-md-12 col-sm-12">
                <h3 className="widget-title">Other Offices</h3>
                <ul className="address-widget">
                  <li>
                    <i className="flaticon-location"><GrMapLocation /></i>
                    <div>
                      <span className="highlight">Dubai</span>
                      <div className="desc">Office #202, Executive Bay-1, Al A'amal Street, Dubai, AE</div>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-location"><GrMapLocation /></i>
                    <div>
                      <span className="highlight">Kuala Lumpur</span>
                      <div className="desc">21, Jalan Walter Granier, Kuala Lumpur, Malaysia</div>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-location"><GrMapLocation /></i>
                    <div>
                      <span className="highlight">Manchester</span>
                      <div className="desc">75, Caythorpe Street, Moss Side, Manchester, M14 4UE</div>
                    </div>
                  </li>
                </ul>
              </div>



            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-6">
                <div className="copyright">
                  <p>© 2023-22 All Rights Reserved. Developed By Zephire Team<a href="https://www.zephiredigital.com/" target="_blank" rel="noopener noreferrer"></a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>



    </div>












  );
}

export default Home;
